export const nameHelperText = "6-30 letters or hypens, start with alphabet, end with alphanumeric";


export const getFormattedDate = (date: Date): string => {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    };

    const timeOptions: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    };

    const formattedDate = date.toLocaleDateString('en-US', options);
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    return `${formattedDate}, ${formattedTime}`;
}

export const getUserNameFromEmail = (email: string) => {
    return email.split('@')[0];  // Get the part before the '@'
  };